import BlankImage from '../assets/phone.png'
import { appConstansts } from '../store/stateModel'
import shop from '../api/shop'
import { store } from '../main'
import {
  loadingProducts,
  loadingMoreProducts,
  storeMoreProducts,
  storeProducts,
  storeProductsAndFilter,
} from '../store/product'
import { toggleCategory, setNewsCategory } from '../store/category'
import {
  addOffset,
  resetOffset,
  setLoadingStep,
  showHots,
} from '../store/common'
import { abortFetching } from '../api/shop'

const BASE_URL = __DEV__ ? 'http://localhost:8099/' : `${window.env.baseURI}`

export const loadHotProducts = () => {
  store.dispatch(loadingProducts(true))
  shop.getHots(
    store.getState().common.user.personal.id,
    productsFromApi => {
      productsFromApi.then(products => {
        if (products) {
          store.dispatch(loadingProducts(false))
          store.dispatch(storeProducts(products))
          store.dispatch(resetOffset())
        }
      })
    },
    0
  )
};

export const loadProducts = (
  altCategory = undefined,
  altBrand = undefined,
  altModel = undefined
) => {
  store.dispatch(loadingProducts(true))
  const storedCategory = localStorage.getItem('ACTIVE_CATEGORY') || 0
  {
    altCategory
      ? shop.getAltProducts(
          altCategory,
          altBrand,
          altModel,
          store.getState().common.user.personal.id,
          productsFromApi => {
            productsFromApi.then(products => {
              if (products) {
                store.dispatch(loadingProducts(false))
                store.dispatch(storeProducts(products))
                store.dispatch(resetOffset())
              }
            })
          },
          0
        )
      : shop.getProducts(
          storedCategory,
          0,
          appConstansts.limit,
          store.getState().product.filter,
          store.getState().product.sortBy,
          store.getState().product.sortOrder,
          store.getState().common.user.personal.id,
          store.getState().customer.actionOnCustomer,
          productsFromApi => {
            productsFromApi.then(products => {
              if (products) {
                store.dispatch(loadingProducts(false))
                altCategory
                  ? store.dispatch(
                      storeProductsAndFilter(
                        products,
                        altCategory,
                        altBrand,
                        altModel
                      )
                    )
                  : store.dispatch(storeProducts(products))
                store.dispatch(resetOffset())
              }
            })
          },
          0
        )
  }
}

export const loadProductsOLD = (category = 0, offset = 0) => {
  offset === 0
    ? store.dispatch(loadingProducts(true))
    : store.dispatch(loadingMoreProducts(true))
  // const storedCategory = localStorage.getItem("OZ_ACTIVE_CATEGORY") || 0;
  const storedCategory = 0
  if (offset === 0) abortFetching()

  shop.getProducts(
    storedCategory,
    24,
    appConstansts.limit,
    store.getState().product.filter,
    store.getState().product.sortBy,
    store.getState().product.sortOrder,
    store.getState().common.user.personal.id,
    store.getState().customer.actionOnCustomer,
    productsFromApi => {
      productsFromApi.then(products => {
        // store.dispatch(setLoadingStep(0));
        // clearInterval(timer);
        if (products) {
          if (offset === 0) {
            store.dispatch(loadingProducts(false))
            store.dispatch(storeProducts(products))
            store.dispatch(resetOffset())
            // if (products.length === 24) loadProducts(storedCategory, 24);
          } else {
            store.dispatch(loadingMoreProducts(false))
            store.dispatch(storeMoreProducts(products))
            store.dispatch(addOffset())
          }
        }
      })
    },
    0
  )
};

export const loadNewsProducts = (offset = 0) => {
  offset === 0
    ? store.dispatch(loadingProducts(true))
    : store.dispatch(loadingMoreProducts(true))
  localStorage.removeItem('OZ_ACTIVE_CATEGORY')
  localStorage.removeItem('OZ_OPEN_CATEGORY')
  store.dispatch(toggleCategory(0, 0))
  store.dispatch(setNewsCategory())
  shop.getNewsProducts(
    offset,
    appConstansts.limit,
    store.getState().product.filter,
    store.getState().product.sortBy,
    store.getState().product.sortOrder,
    store.getState().common.user.personal.id,
    store.getState().common.actionOnCustomer,
    productsFromApi => {
      productsFromApi.then(products => {
        if (offset === 0) {
          store.dispatch(loadingProducts(false))
          store.dispatch(storeProducts(products))
          store.dispatch(resetOffset())
          if (products.length === 24) loadNewsProducts(24)
        } else {
          store.dispatch(loadingMoreProducts(false))
          store.dispatch(storeMoreProducts(products))
          store.dispatch(addOffset())
        }
      })
    },
    0
  )
};

export const searchProducts = idModel => {
  store.dispatch(loadingProducts(true))
  shop.searchProducts(
    idModel,
    store.getState().common.actionOnCustomer,
    store.getState().common.user.personal.id,

    searchedProductsFromApi => {
      searchedProductsFromApi.then(searchedProducts => {
        // dispatch(setSearchedProductUnsafe(searchedProducts));
        // dispatch(loadingSearchUnsafe(false));
        store.dispatch(loadingProducts(false))
        store.dispatch(storeProducts(searchedProducts))
        store.dispatch(resetOffset())
      })
    }
  )
};

export const hostPath = (path) =>
  path ? `${BASE_URL}/${path}` : null;

export const productImageThumbnailPath = (name, id, type='jpg') =>
  name !== '' && name !== null && !__DEV__
    ? `${BASE_URL}/public/img/products/${id}/${name}-thumbnail.${type ? type : 'jpg'}`
    : BlankImage

export const productImagePath = (name, id) =>
  name !== '' && name !== null && !__DEV__
    ? BASE_URL + '/public/img/products/' + id + '/' + name + '-600x600.jpg'
    : BlankImage

export const createMarkup = html => {
  return { __html: html }
};

export const youtubeVideo = video =>
  video
    .replace('{youtube}', '')
    .replace('{/youtube}', '')
    .split('|')



// WEBPACK FOOTER //
// ./src/utils/product.util.js